function isObject(item) {
	return (item && typeof item === 'object' && !Array.isArray(item));
}
  
function mergeDeep(target, ...sources) {
	if (!sources.length) return target;
	const source = sources.shift();
	if (isObject(target) && isObject(source)) {
		for (const key in source) {
			if (isObject(source[key])) {
				if (!target[key]) Object.assign(target, { [key]: {} });
				mergeDeep(target[key], source[key]);
			} else {
				Object.assign(target, { [key]: source[key] });
			}
		}
	}
	return mergeDeep(target, ...sources);
}

// Cache translations to avoid repeated imports
const translationCache = new Map();

export async function getTranslations(locale) {
	// Check cache first
	if (translationCache.has(locale)) {
		return translationCache.get(locale);
	}

	try {
		const jsonfile = await import(`./translation-${locale}.json`);
		let result = jsonfile.default;

		if (locale !== 'en' && locale !== 'hi') {
			// Only load English fallback if not already cached
			if (!translationCache.has('en')) {
				const jsonEnfile = await import('./translation-en.json');
				translationCache.set('en', jsonEnfile.default);
			}
			const englishTranslations = translationCache.get('en');
			result = mergeDeep({ ...englishTranslations }, result);
		}

		// Cache the result
		translationCache.set(locale, result);
		return result;
	} catch (error) {
		console.error(`Failed to load translations for locale: ${locale}`, error);
		// Fallback to English
		if (locale !== 'en') {
			return getTranslations('en');
		}
		return {};
	}
}
